export const GRAPH = {
  BASE_URL: 'https://graph.microsoft.com/v1.0',
  SCOPES: {
    USER_READ: 'User.Read',
    PRESENCE_READ: 'Presence.Read.All',
    SUBSCRIPTION_READ: 'Subscription.Read.All'
  }
};

export const graphEndpoints = {
  me: {
    uri: `${GRAPH.BASE_URL}/me`,
    scopes: [GRAPH.SCOPES.USER_READ]
  },
  presence: {
    uri: `${GRAPH.BASE_URL}/me/presence`,
    scopes: [GRAPH.SCOPES.PRESENCE_READ]
  },
  subscriptions: {
    uri: `${GRAPH.BASE_URL}/subscriptions`,
    scopes: [GRAPH.SCOPES.SUBSCRIPTION_READ]
  }
};

/**
 * Microsoft Authentication Library Configuration MSAL
 **/
export const msalConfig = {
  auth: {
    clientId: '',
    authority: '',
    redirectUri: '',
    postLogoutRedirectUri: '/',
    clientCapabilities: ['CP1'] // Conditional Access Policy
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false
  }
};
